let globalVariable = {}

function setVariable(key, value) {
  globalVariable[key] = value
}

export { globalVariable, setVariable }
